export enum MPUDetailSectionID {
    BuildDetails = 'build-details',
    Details = 'details',
    HistoricalFaults = 'historical-faults',
    HistoricalSummary = 'historical-summary',
    Map = 'map',
    Schedule = 'schedule',
    Status = 'status',
}
